import { FILE_TYPES } from '../../../formFileTypesEnum';
import { VENDORS } from '../../../formQuestionsEnum';

export const NURSING_VENDOR_FIELDS = [
  {
    question: VENDORS.STAFFING_AGENCY_VENDOR,
    title: 'Staffing agency vendor',
    allowMultipleVendors: true,
    invoiceFileTypeId: FILE_TYPES.STAFFING_AGENCY_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.STAFFING_AGENCY_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.EMR_SOFTWARE_VENDOR,
    title: 'EMR software vendor',
    invoiceFileTypeId: FILE_TYPES.EMR_SOFTWARE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.EMR_SOFTWARE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.DME_SUPPLY_VENDOR,
    title: 'DME supply vendor',
    invoiceFileTypeId: FILE_TYPES.DME_SUPPLY_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.DME_SUPPLY_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.MEDICAL_DIRECTOR_VENDOR,
    title: 'Medical director vendor',
    invoiceFileTypeId: FILE_TYPES.MEDICAL_DIRECTOR_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.MEDICAL_DIRECTOR_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.MEDICAL_SUPPLIES_VENDOR,
    title: 'Medical supplies vendor',
    invoiceFileTypeId: FILE_TYPES.MEDICAL_SUPPLIES_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.MEDICAL_SUPPLIES_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.PHARMACY_VENDOR,
    title: 'Pharmacy vendor',
    invoiceFileTypeId: FILE_TYPES.PHARMACY_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.PHARMACY_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.PHARMACY_CONSULTANT_VENDOR,
    title: 'Pharmacy consultant vendor',
    invoiceFileTypeId: FILE_TYPES.PHARMACY_CONSULTANT_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.PHARMACY_CONSULTANT_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.LAB_COVID_TEST_VENDOR,
    title: 'Lab COVID test',
    invoiceFileTypeId: FILE_TYPES.LAB_COVID_TEST_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.LAB_COVID_TEST_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.LABS_VENDOR,
    title: 'Labs vendor',
    invoiceFileTypeId: FILE_TYPES.LABS_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.LABS_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.X_RAY_VENDOR,
    title: 'X-ray vendor',
    invoiceFileTypeId: FILE_TYPES.XRAY_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.XRAY_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.DME_RENTAL_VENDOR,
    title: 'DME rental vendor',
    invoiceFileTypeId: FILE_TYPES.DME_RENTAL_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.DME_RENTAL_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.WHEELCHAIR_TRANSPORT_VENDOR,
    title: 'Wheelchair transport vendor',
    invoiceFileTypeId: FILE_TYPES.WHEELCHAIR_TRANSPORT_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.WHEELCHAIR_TRANSPORT_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.STRETCHER_TRANSPORT_VENDOR,
    title: 'Stretcher transport vendor',
    invoiceFileTypeId: FILE_TYPES.STRETCHER_TRANSPORT_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.STRETCHER_TRANSPORT_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.MEDICAL_WASTE_VENDOR,
    title: 'Medical waste vendor',
    invoiceFileTypeId: FILE_TYPES.MEDICAL_WASTE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.MEDICAL_WASTE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.OXYGEN_PROVIDER,
    title: 'Oxygen provider',
    invoiceFileTypeId: FILE_TYPES.OXYGEN_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.OXYGEN_PROVIDER_CONTRACT,
  },
  {
    question: VENDORS.OXYGEN_RENTAL_PROVIDER,
    title: 'Oxygen rental provider',
    invoiceFileTypeId: FILE_TYPES.OXYGEN_RENTAL_PROVIDER_INVOICE,
    contractFileTypeId: FILE_TYPES.OXYGEN_RENTAL_PROVIDER_CONTRACT,
  },
  {
    question: VENDORS.ENTERALS_OUTS_PART_B_SUPPLY_BILLING_VENDOR,
    title: 'Enterals. OUTs part B supply billing',
    invoiceFileTypeId: FILE_TYPES.ENTERALS_OUTS_PART_B_SUPPLY_BILLING_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.ENTERALS_OUTS_PART_B_SUPPLY_BILLING_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.WOUND_CARE_PART_B_SUPPLY_BILLING_VENDOR,
    title: 'Wound care part B supply billing',
    invoiceFileTypeId: FILE_TYPES.WOUND_CARE_PART_B_SUPPLY_BILLING_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.WOUND_CARE_PART_B_SUPPLY_BILLING_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.WOUND_PHYSICIAN_NURSE_VENDOR,
    title: 'Wound physician/nurse',
    invoiceFileTypeId: FILE_TYPES.WOUND_PHYSICIAN_NURSE_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.WOUND_PHYSICIAN_NURSE_VENDOR_CONTRACT,
  },
  {
    question: VENDORS.PICC_MIDLINE_INSERTION_VENDOR,
    title: 'PICC/midline insertion',
    invoiceFileTypeId: FILE_TYPES.PICC_MIDLINE_INSERTION_VENDOR_INVOICE,
    contractFileTypeId: FILE_TYPES.PICC_MIDLINE_INSERTION_VENDOR_CONTRACT,
  },
];
